var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 319,
    viewBox: "0 0 258 319",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M44.872 231.835.194 269.28l38.63-43.657z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m191.997 82.556-37.769 36.769-6.995-30.454a40.328 40.328 0 0 1 11.175-37.924L179.924 30l12.073 52.556z",
    fill: "#FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m191.997 82.556-37.769 36.769 30.257 7.809a40.333 40.333 0 0 0 38.212-10.155l21.517-20.946-52.217-13.477z",
    fill: "#FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m61.915 199.884 9.305 9.558 113.26-110.26.35.36-.35-.36a5.397 5.397 0 0 0 1.642-3.818 5.393 5.393 0 0 0-1.54-3.86l-1.729-1.778a5.434 5.434 0 0 0-7.677-.103L61.915 199.884zm9.4 10.758a.5.5 0 0 1-.463-.141l-10.005-10.276a.5.5 0 0 1 .01-.71l113.62-110.61a6.439 6.439 0 0 1 9.094.121l1.73 1.778a6.391 6.391 0 0 1 1.824 4.574 6.393 6.393 0 0 1-1.946 4.523L71.56 210.511a.5.5 0 0 1-.246.13z",
    fill: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m102.698 186-47.512 46.253c-3.871 3.769-10.064 3.686-13.833-.185l-2.854-2.932c-3.77-3.872-3.687-10.068.186-13.838l47.508-46.25L102.698 186z",
    fill: "#FFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m179.635 30.981-20.878 20.325c-9.9 9.638-14.129 23.989-11.036 37.453l6.796 29.585 36.929-35.95-11.81-51.413zm-25.304 88.834a.503.503 0 0 1-.591-.378l-6.996-30.454c-3.17-13.802 1.164-28.515 11.314-38.395l21.517-20.947a.502.502 0 0 1 .838.247l12.073 52.556c.04.17-.014.35-.14.471l-37.768 36.769a.5.5 0 0 1-.247.131z",
    fill: "#000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m155.216 119.062 29.395 7.586c13.377 3.453 27.837-.39 37.737-10.028l20.877-20.325-51.08-13.183-36.929 35.95zm47.694 8.955c-6.061 1.272-12.415 1.185-18.55-.398l-30.257-7.809a.502.502 0 0 1-.224-.845l37.769-36.768a.5.5 0 0 1 .475-.126l52.216 13.476a.502.502 0 0 1 .224.845l-21.517 20.947c-5.609 5.46-12.648 9.107-20.136 10.678z",
    fill: "#000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M184.83 99.542 71.21 210.151l-10.005-10.276 113.62-110.61a5.93 5.93 0 0 1 8.386.111l1.73 1.777a5.933 5.933 0 0 1-.112 8.39",
    fill: "#FFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m86.184 169.757-47.15 45.9a9.225 9.225 0 0 0-2.807 6.529 9.224 9.224 0 0 0 2.631 6.6l2.855 2.932c3.569 3.667 9.456 3.746 13.124.176l47.152-45.903-15.805-16.234zM50.49 235.302c-3.335.7-6.949-.267-9.496-2.884l-2.854-2.932a10.222 10.222 0 0 1-2.915-7.314 10.22 10.22 0 0 1 3.111-7.233l47.508-46.25a.5.5 0 0 1 .709.01l16.504 16.951a.5.5 0 0 1-.01.71l-47.511 46.252a10.224 10.224 0 0 1-5.046 2.69z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDart);
export default __webpack_public_path__ + "static/media/dart.50b11954d429b2ac6ba74f18f700ab34.svg";
export { ForwardRef as ReactComponent };